import { Component, OnInit, signal, inject, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { isAuth } from './auth';

interface SocialLink {
  label: string;
  url: string;
  iconClass: string;
  color: string;
}

@Component({
  selector: 'app-wwwwww',
  standalone: true,
  imports: [CommonModule],
  template: `
    <footer class="text-center text-light">
      <!-- Modal Nativo HTML5 utilizando la Capa Superior (Top Layer) -->
      <dialog #mapDialog class="custom-native-modal shadow-lg">
        <div class="modal-content bg-dark text-light border-secondary h-100 d-flex flex-column">
          <div class="modal-header border-secondary p-3 d-flex justify-content-between align-items-center flex-shrink-0">
            <h5 class="modal-title mb-0" id="mapModalLabel">{{ modalTitle() }}</h5>
            <button
              type="button"
              class="btn btn-info btn-sm"
              (click)="closeModal()"
            >Cerrar</button>
          </div>
          <div class="modal-body p-0 flex-grow-1 h-100 overflow-hidden">
            @if (currentIframeUrl()) {
              <iframe
                [src]="currentIframeUrl()"
                [title]="modalTitle()"
                allowfullscreen
                loading="lazy"
                class="w-100 h-100 d-block"
                style="border: 0;"
              ></iframe>
            }
          </div>
        </div>
      </dialog>
              
      <div class="container py-3">
            
        <!-- Sección Información Institucional -->
        <div class="text-center">
          <h3 class="text-light my-0 ffont">
            Escuela Superior de Formación Artística
          </h3>
          <div class="text-light-50">"Felipe Guamán Poma de Ayala"</div>
        @if (auth.name) {
          <div class="">Bienvenido: {{ auth.name }}</div>
        }

          @if (imageSrc()) {
            <div class="">
              <img
                class=""
                style="width: 115px; height: 115px;"
                [src]="imageSrc()"
                alt="Logo ESFAPA"
              />
            </div>
          }

          <div class="text-secondary" style="font-size: 0.75rem;">
            Copyright © ESFAPA Ayacucho {{ currentYear }}
        </div>
        <div class="w-100 d-flex justify-content-center gap-2 flex-wrap">
          <button class="btn btn-outline-light d-flex align-items-center gap-1" (click)="navigateToDocumentoswww('articulos')"><i class="bi bi-journal-text"></i>Artículos</button>
          <button class="btn btn-outline-light d-flex align-items-center gap-1" (click)="navigateToDocumentoswww('model')"><i class="bi bi-journal-text"></i>Model</button>
          <button class="btn btn-outline-light d-flex align-items-center gap-1" (click)="navigateToDocumentos()"><i class="bi bi-mortarboard-fill"></i> Cursos</button>
          <button class="btn btn-lg btn-outline-light d-flex align-items-center gap-1" (click)="Stats()"><i class="bi bi-bar-chart-fill"></i>Estadísticas</button>
          <button class="btn btn-outline-light d-flex align-items-center gap-1" (click)="navigateToDocumentosblog()"><i class="bi bi-file-post"></i> Blog</button>
          <button class="btn btn-outline-light d-flex align-items-center gap-1" (click)="Tramite()"><i class="bi bi-receipt"></i> Trámite</button>
          <button class="btn btn-outline-light d-flex align-items-center gap-1" (click)="Audio()"><i class="bi bi bi-badge-hd"></i> HiRes</button>
         </div>

      </div>

        <!-- Sección Dirección -->
        <div class="text-center">
          <div class="mb-0 text-light-50" style="font-size: 0.9rem;">
            Jr. Mariano Melgar Nº 398, Distrito Jesús Nazareno - Huamanga, Ayacucho
        </div>
          <div class="text-light-50" style="font-size: 0.9rem;">Teléfono: 066-287499</div>
        </div>

        <!-- Botones para abrir los Modales de Mapas -->
        <div class="d-flex justify-content-center gap-2 flex-wrap">
          <button
            type="button"
            class="btn btn-outline-info d-flex align-items-center gap-1"
            (click)="openModal('mapa')"
          >
            <i class="bi bi-geo-alt-fill"></i> Ver Ubicación
          </button>

          <button
            type="button"
            class="btn btn-outline-light d-flex align-items-center gap-1"
            (click)="openModal('streetview')"
          >
            <i class="bi bi-person-walking"></i> Street View
          </button>
        </div>

        <!-- Sección Redes Sociales -->
        <div class="text-center">
          <div class="d-flex justify-content-center flex-wrap gap-1">
            @for (social of socialLinks; track social.label) {
              <button
                type="button"
                class="btn p-1"
                [attr.aria-label]="social.label"
                (click)="openInNewTab(social.url)"
              >
                <i
                  [class]="social.iconClass"
                  [style.color]="social.color"
                  style="font-size: 21px;"
                ></i>
              </button>
            }
          </div>
        </div>
      </div>
    </footer>
  `,
  styles: [`
    .ffont {
      font-family: inherit;
    }

    .custom-native-modal {
      width: 98vw;
      height: 98vh;
      height: 92dvh; /* Adapts to modern mobile viewports (dynamic viewport height) */
      max-width: 1140px;
      border: none;
      border-radius: 8px;
      padding: 0;
      background: transparent;
      margin: auto;
    }

    /* Fondo oscuro nativo del modal */
    .custom-native-modal::backdrop {
      background: rgba(0, 0, 0, 0.75);
      backdrop-filter: blur(4px);
    }
  `]
})
export class WwwwwwComponent implements OnInit {
  @ViewChild('mapDialog') mapDialog!: ElementRef<HTMLDialogElement>;
  
  private readonly sanitizer = inject(DomSanitizer);
  private router = inject(Router);

  readonly currentYear = new Date().getFullYear();
  readonly pageName = 'ESFA';
  readonly imageSrc = signal<string>('');

  readonly currentIframeUrl = signal<SafeResourceUrl | null>(null);
  readonly modalTitle = signal<string>('');

  private readonly iframeSources: Record<'mapa' | 'streetview', { title: string; url: SafeResourceUrl }> = {
    mapa: {
      title: 'Ubicación - ESFAPA Ayacucho',
      url: this.sanitizer.bypassSecurityTrustResourceUrl(
        'https://maps.google.com/maps?width=100%25&height=500&hl=es&q=+(Escuela%20de%20Bellas%20Artes%20Felipe%20Guam%C3%A1n%20Poma%20de%20Ayala-Ayacucho)&t=k&z=18&ie=UTF8&iwloc=B&output=embed'
      )
    },
    streetview: {
      title: 'Google Street View - ESFAPA Ayacucho',
      url: this.sanitizer.bypassSecurityTrustResourceUrl(
        'https://www.google.com/maps/embed?pb=!4v1750534065961!6m8!1m7!1syWFe4Rj4ga1j6fqlrkocMA!2m2!1d-13.15626194436401!2d-74.21787224051161!3f200.16657941141062!4f3.2355809602561294!5f0.7820865974627469'
      )
    }
  };

  readonly socialLinks: SocialLink[] = [
    { label: 'WhatsApp', url: 'https://api.whatsapp.com/send?phone=+51966999215&text=Hola%20bienvenido', iconClass: 'bi bi-whatsapp', color: '#069d12' },
    { label: 'Facebook', url: 'https://web.facebook.com/bellasartes.ayacucho', iconClass: 'bi bi-facebook', color: '#0672a0' },
    { label: 'Messenger', url: 'https://m.me/bellasartes.ayacucho', iconClass: 'bi bi-messenger', color: '#00B2FF' },
    { label: 'Instagram', url: 'https://instagram.com/bellasartes.ayacucho', iconClass: 'bi bi-instagram', color: '#ff00ee' },
    { label: 'Google / Blogspot', url: 'https://bellasartes.blogspot.com', iconClass: 'bi bi-google', color: '#ff4800' },
    { label: 'YouTube', url: 'https://www.youtube.com/channel/UCkYf1NyZ1kUl3965WgeL6rw', iconClass: 'bi bi-youtube', color: '#ff0011' },
    { label: 'TikTok', url: 'https://www.tiktok.com/@bellasartes.ayacucho', iconClass: 'bi bi-tiktok', color: '#efeaf3ff' }
  ];

  auth: any = isAuth();

  ngOnInit(): void {
    const day = new Date().getDay();
    const svgIndex = day === 0 ? 7 : day;
    this.imageSrc.set(`/www${svgIndex}.svg`);
  }

  openModal(type: 'mapa' | 'streetview'): void {
    const selectedSource = this.iframeSources[type];
    this.modalTitle.set(selectedSource.title);
    this.currentIframeUrl.set(selectedSource.url);
    this.mapDialog.nativeElement.showModal();
  }

  closeModal(): void {
    this.mapDialog.nativeElement.close();
    this.currentIframeUrl.set(null);
  }

  openInNewTab(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  navigateToDocumentos() { this.router.navigate(['/documentos']); }
  Stats() { this.router.navigate(['/stats']); }
  navigateToDocumentostramite() { this.router.navigate(['/documentos']); }
  Tramite() { this.router.navigate(['/tramite']); }
  navigateToDocumentosblog() { this.router.navigate(['/blog']); }
  Audio() { this.router.navigate(['/audio']); }
  navigateToDocumentoswww(url:any) { this.router.navigate([url]); }
}